export enum ItemsAdvanceSearchFilterTypeEnum {
  PRODUCTS_IDS = "productIds",
  CREATED_AT_LOCATION_IDS = "createdAtLocationIds",
  CURRENT_LOCATION_IDS = "currentLocationIds",
}
